import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyBqorCQc-b-nrzMDe86PrfEPDKizG5pgqw',
  authDomain: 'atrux-1cccf.firebaseapp.com',
  projectId: 'atrux-1cccf',
  storageBucket: 'atrux-1cccf.firebasestorage.app',
  messagingSenderId: '1003712693359',
  appId: '1:1003712693359:web:474ecc6914b75d7002f99a',
  measurementId: 'G-F1S67CM67D',
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { analytics };
export default app;
